import {ACTIONS, hasGlobalPermission} from "../../../utils/user-access";

export const getPlaceholder = (placeholder) => hasGlobalPermission(ACTIONS.EDIT_MEMBERS) ? placeholder : "";

export const getInputDisable = (isExternalMember) => !hasGlobalPermission(ACTIONS.EDIT_MEMBERS) || isExternalMember;

export const memberDataFields = ["avatar", "first_name", "last_name", "email", "phone", "password", "confirm_password"];